<template>
  <div>
    <a
      v-if="isDownload"
      class="file file--download"
      :href="file?.url"
      :download="file?.file_name"
      target="_blank"
      @click.prevent="downloadFile">
      <VIcon class="file__icon" width="23" height="27" icon-name="File" />
      <span class="file__name">
        {{ file?.name || file?.title }}
      </span>
      <button
        v-if="showDelete"
        class="icon__btn-delete btn"
        :class="iconNameBtnDelete === 'YellowDelete' && 'icon__btn-delete--yellow'"
        @click.prevent="onDeleteFile(file)">
        <VIcon :icon-name="iconNameBtnDelete" :width="iconSize" :height="iconSize" />
      </button>
    </a>

    <div v-else class="file">
      <VIcon class="file__icon" width="23" height="27" icon-name="File" />
      <span class="file__name">
        {{ file?.name || file?.title }}
      </span>

      <button
        v-if="showDelete"
        class="icon__btn-delete btn"
        :class="iconNameBtnDelete === 'YellowDelete' && 'icon__btn-delete--yellow'"
        @click.prevent="onDeleteFile(file)">
        <VIcon :icon-name="iconNameBtnDelete" :width="iconSize" :height="iconSize" />
      </button>
    </div>
  </div>
</template>

<script>
import VIcon from '@/components/ui/icon/VIcon'
import { computed } from 'vue'

export default {
  components: { VIcon },
  props: {
    file: {
      type: Object,
      required: true,
    },
    showDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDownload: {
      type: Boolean,
      required: false,
    },
    iconNameBtnDelete: {
      type: String,
      required: false,
      default: 'DeleteFile',
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ['onDelete'],
  setup(props, { emit }) {
    const onDeleteFile = (file) => {
      emit('onDelete', file.id || file.name, {
        id: file.id || null,
        name: file.name || file.title,
        index: props.index,
      })
    }
    const downloadFile = async () => {
      try {
        const response = await fetch(props.file.url)
        if (!response.ok) {
          throw new Error('Ошибка сети при загрузке файла')
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = props.file.file_name || 'download'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        console.error('Возникла проблема с операцией загрузки:', error)
        // Fallback or user notification
        window.open(props.file.url, '_blank')
      }
    }

    const iconSize = computed(() => {
      switch (props.iconNameBtnDelete) {
        case 'DeleteFile':
          return 27
        case 'YellowDelete':
          return 38
        default:
          return 0
      }
    })

    return {
      iconSize,
      onDeleteFile,
      downloadFile,
    }
  },
}
</script>
